import { BaseProxy, type ProxyMethods } from '@/proxies/Proxy'

export default class ShipmentEventProxy extends BaseProxy implements ProxyMethods {
  public endpoint = 'shipment-events'

  getList(params: URLSearchParams) {
    return this.submit('get', `/${this.endpoint}?${params}`)
  }
}
